<template>
	<div v-if="post" class="author">
		<h2 class="level-four-heading">Skrivet av:</h2>
		<div class="authorContainer">
			<ximg
				:src="avatarUrl"
				:style="avatarStyle"
				:class="['avatar-small pixelated', avatarClass]"
				ariaLabel="avatar"
				eager
				role="img"
			/>
			<div class="authorInfo">
				<span class="authorname-and-logo">{{ post.user.username }} <span class="sub-title"><span class="wh-logo"/> Jobbar på Webhallen</span> </span>
				<span class="level sub-title">Level {{ post.user.rankLevel }} {{ post.user.avatar.class.title }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import waja from 'waja';
import memberUtils from 'utils/member';

export default {
	props: {
		authorId: {
			type: String,
			required: null,
		}
	},
	data () {
		return {
			post: null,
		}
	},
	mounted () {
		this.getAuthor(this.authorId);
	},
	methods: {
		getAuthor (id) {
			waja.get('user/' + id).on('success', res => {
				this.post = {
					user: res.data.user
				}
			}).go();
		},
	},
	computed: {
		avatarStyle () {
			return memberUtils.avatarStyle(this.post);
		},
		avatarUrl () {
			return memberUtils.avatarUrl(this.post);
		},
		avatarClass () {
			if (! (this.post && this.post.avatar)) {
				return 'anonymous';
			}
			return '';
		},
	}
}
</script>
